// App.js
import React,{useState,useRef} from 'react';
import {Component} from 'react'
import swal from 'sweetalert';
import IdleTimer from 'react-idle-timer'
 
function IdleTimerContainer()
{
  
  
    const [modelIsOpen, setmodelIsOpen] = useState(false);
   const idleTimeref = useRef(null); 
   const sessionTimeoutref = useRef(null); 
  
 const handleOnIdle=()=>
 { 
    
  swal({
    title: "Your Session is Expired",
    text: "Please click Here to Active your Session",
    icon: "warning",
    
    buttons: ["Logout","Reactive My Seesion"],
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      StayActve();
    } else {
      LogOut();
    }
  });
    sessionTimeoutref.current=setTimeout(LogOut,10000);
    //this.idleTimer.reset();
     
    //console.log('last active', this.idleTimer.getLastActiveTime())
  } 
  const LogOut=()=>{
    setmodelIsOpen(false);
    clearTimeout(sessionTimeoutref.current);
    localStorage.clear()
   window.location.href="/"
    
  }
 
  const StayActve=()=>{
    clearTimeout(sessionTimeoutref.current);
    setmodelIsOpen(false);
    
  }
 
    return (
      <div>
       
        <IdleTimer
          ref={idleTimeref}
          timeout={1000*60*10} 
         
          onIdle={handleOnIdle}
       
          debounce={500}
        />

          
      </div>
    );
  }


export default IdleTimerContainer;